var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM17.77 9.06V10.83C16.59 10.83 15.5 10.45 14.61 9.81V14.43C14.61 16.74 12.73 18.61 10.43 18.61C9.54 18.61 8.71 18.33 8.03 17.85C6.95 17.09 6.24 15.84 6.24 14.42C6.24 12.11 8.12 10.24 10.42 10.24C10.61 10.24 10.8 10.26 10.98 10.28V12.6C10.8 12.54 10.61 12.51 10.42 12.51C9.37 12.51 8.51 13.37 8.51 14.42C8.51 15.15 8.93 15.79 9.53 16.11C9.8 16.25 10.1 16.33 10.42 16.33C11.45 16.33 12.29 15.51 12.33 14.49V5.39H14.61C14.61 5.59 14.63 5.78 14.66 5.97C14.82 6.84 15.33 7.58 16.05 8.04C16.55 8.36 17.14 8.55 17.77 8.55V9.06Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.9578492be4f6144f508cb3a5dc852f87.svg";
export { ForwardRef as ReactComponent };